/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
import initRouteInfo from '@/helper-functions/route-info/init-route-info';
import { makeMutations } from '@/helper-functions/store/store';
import {
  defaultLimit,
  getBiuraNaMape,
  getWojewodztwa,
  getMiasta,
  getWyszukajBiuraQueryParams,
  pobierz,
  wyszukaj,
  defaultWojewodztwo,
  defaultMiasto,
  calcLimit,
  checkShouldFillListingOnInit,
} from '~/storeServices/biura';

export const state = () => ({
  koordynatyLoaded: false,
  listingLoaded: false,
  limit: defaultLimit,
  wyszukajResult: {},

  wojewodztwo: defaultWojewodztwo,
  miasto: defaultMiasto,
  czy7DniWTygodniu: false,
  czyFirmowe: false,
  szerokoscGeo: null,
  dlugoscGeo: null,

  biuraDoPobraniaIds: [],
  routeInfo: initRouteInfo(),
  listing: [],
});
export const mutations = {
  ...makeMutations([
    'koordynatyLoaded',
    'listingLoaded',
    'limit',
    'wyszukajResult',
    'routeInfo',
    'listing',
    'wojewodztwo',
    'miasto',
    'czy7DniWTygodniu',
    'czyFirmowe',
    'szerokoscGeo',
    'dlugoscGeo',
  ]),
};

export const getters = {
  listingLoaded: (state) => state.listingLoaded,
  limit: (state) => state.limit,
  limitNotDefault: (state) => state.limit !== defaultLimit,
  shouldHideMoreBtn: (state, getters) => {
    if (!getters.koordynaty) return true;

    return getters.koordynaty.length <= getters.listing.length;
  },
  shouldShowMoreBtn: (state, getters) => {
    if (!getters.koordynaty || !getters.koordynaty.length) return false;

    if (!getters.listing || !getters.listing.length) return false;

    if (getters.koordynaty.length > getters.listing.length) return true;

    if (getters.listing.length > getters.listingWithLimit.length) return true;

    return false;
  },
  koordynaty: (state) => (state.wyszukajResult ? state.wyszukajResult.Koordynaty : []),
  koordynatyNaMape: (state) => getBiuraNaMape(state.wyszukajResult.Koordynaty),
  wojewodztwa: (state) => getWojewodztwa(state.wyszukajResult.Wojewodztwa || []),
  miasta: (state) => getMiasta(state.wyszukajResult.Miasta || []),
  czy7DniWTygodniu: (state) => state.czy7DniWTygodniu,
  czyFirmowe: (state) => state.czyFirmowe,

  listing: (state) => (state.listing ? state.listing : []),
  listingWithLimit: (state, getters) => getters.listing.slice(0, state.limit),
  wyszukajBiuraQueryParams: (state, getters) => getWyszukajBiuraQueryParams(getters.wyszukajFiltry),
  biuraDoPobraniaIds: (state) => state.biuraDoPobraniaIds,
  wyszukajFiltry: (state) => ({
    wojewodztwo: state.wojewodztwo,
    miasto: state.miasto,
    czy7DniWTygodniu: state.czy7DniWTygodniu,
    czyFirmowe: state.czyFirmowe,
    szerokoscGeo: state.szerokoscGeo,
    dlugoscGeo: state.dlugoscGeo,
  }),
  mapCoords: (state) => {
    if (state.szerokoscGeo === undefined || state.szerokoscGeo === null || state.dlugoscGeo === undefined || state.dlugoscGeo === null) {
      return null;
    }

    return {
      lat: state.szerokoscGeo,
      lng: state.dlugoscGeo,
    };
  },
};

export const actions = {
  async wyszukaj({ commit, getters }) {
    commit('koordynatyLoaded', false);
    const wyszukajResult = await wyszukaj({ queryParams: getters.wyszukajBiuraQueryParams, $http: this.$http });

    commit('wyszukajResult', wyszukajResult);
    commit('koordynatyLoaded', true);
  },
  async pobierz({ commit, getters }, reset = false) {
    commit('listingLoaded', false);
    if (reset) {
      commit('listing', []);
    }

    const apiResult = await pobierz({
      $http: this.$http,
      listing: getters.listing,
      listingWithLimit: getters.listingWithLimit,
      koordynaty: getters.koordynaty,
      reset,
    });

    const listing = reset ? apiResult : getters.listing.concat(apiResult);

    commit('listing', listing);
    commit('listingLoaded', true);
  },
  changeMiasto({ commit, dispatch }, payload) {
    commit('miasto', payload);
    dispatch('resetFiltryDolne');
    commit('listing', []);
    if (!payload.Wartosc) {
      commit('limit', defaultLimit);
    }
  },
  changeWojewodztwo({ commit, dispatch }, payload) {
    commit('miasto', defaultMiasto);
    commit('wojewodztwo', payload);
    dispatch('resetFiltryDolne');
    commit('listing', []);
    if (!payload.Wartosc) {
      commit('limit', defaultLimit);
    }
  },
  changeLimit({ commit, state }, payload = 1) {
    const limit = calcLimit({ multiplier: payload, currentLimit: state.limit });

    commit('limit', limit);
  },
  changeCzyFirmowe({ commit }, payload) {
    commit('czyFirmowe', payload);
  },
  changeCzy7DniWTygodniu({ commit }, payload) {
    commit('czy7DniWTygodniu', payload);
  },
  setFiltryLokalizacja({ commit }, payload) {
    commit('szerokoscGeo', payload.szerokoscGeo);
    commit('dlugoscGeo', payload.dlugoscGeo);
    commit('czyFirmowe', null);
    commit('czy7DniWTygodniu', null);
    commit('wojewodztwo', defaultWojewodztwo);
    commit('miasto', defaultMiasto);
  },
  resetFiltryLokalizacja({ commit }, payload) {
    commit('szerokoscGeo', null);
    commit('dlugoscGeo', null);
  },
  async localiseSuccess({ commit, dispatch }, payload) {
    const { coords } = payload;

    dispatch('setFiltryLokalizacja', {
      szerokoscGeo: coords.latitude,
      dlugoscGeo: coords.longitude,
    });
    await dispatch('wyszukaj');
    await dispatch('pobierz', true);
  },
  setFiltryGorne({ commit, dispatch }, payload) {
    if (!payload.value) return;

    if (!payload.value.DodatkowePola) {
      dispatch('changeWojewodztwo', defaultWojewodztwo);
      dispatch('changeMiasto', defaultMiasto);
      return;
    }

    const {
      wojewodztwoUrl, wojewodztwo: wojewodztwoNazwa, miastoUrl, miasto: miastoNazwa,
    } = payload.value.DodatkowePola;

    if (wojewodztwoUrl) dispatch('changeWojewodztwo', { Wartosc: wojewodztwoUrl, Nazwa: wojewodztwoNazwa });

    if (miastoUrl) dispatch('changeMiasto', { Wartosc: miastoUrl, Nazwa: miastoNazwa });
  },
  resetFiltryDolne({ commit }) {
    commit('czyFirmowe', null);
    commit('czy7DniWTygodniu', null);
  },
  async initialize({ commit, dispatch }, payload) {
    dispatch('setFiltryGorne', payload);
    await dispatch('wyszukaj');
    if (!checkShouldFillListingOnInit(payload.value)) return;

    await dispatch('pobierz');
  },
  async routeChange({ commit, dispatch, state }) {
    const wojewodztwo = state.routeInfo?.DodatkowePola?.wojewodztwoUrl ? {
      Wartosc: state.routeInfo?.DodatkowePola?.wojewodztwoUrl,
      Nazwa: state.routeInfo?.DodatkowePola?.wojewodztwo,
    } : defaultWojewodztwo;

    const miasto = state.routeInfo?.DodatkowePola?.miastoUrl ? {
      Wartosc: state.routeInfo?.DodatkowePola?.miastoUrl,
      Nazwa: state.routeInfo?.DodatkowePola?.miasto,
    } : defaultMiasto;

    commit('wojewodztwo', wojewodztwo);
    commit('miasto', miasto);
    await dispatch('wyszukaj');
    if (!checkShouldFillListingOnInit(state.routeInfo) && !state.wojewodztwo.Wartosc) return;

    await dispatch('pobierz');
  },
  async changeDropdownWojewodztwo({ commit, dispatch }, payload) {
    dispatch('changeWojewodztwo', payload);
    dispatch('resetFiltryLokalizacja');
    await dispatch('wyszukaj');
    await dispatch('pobierz', true);
  },
  async changeDropdownMiasto({ commit, dispatch }, payload) {
    dispatch('changeMiasto', payload);
    dispatch('resetFiltryLokalizacja');
  },
};
